<div class="dialogContainer">
  <div class="header">
    <h2>Special Charges</h2>
  </div>
  <div class="content">
    <div class="tableContainer">
      @if (!selectedBreak) {
        <table class="breaksTable">
          <thead>
            <tr>
              <td class="centeredCell headerCell tableCell"></td>
              <td class="centeredCell headerCell tableCell">Factor</td>
              <td class="centeredCell headerCell tableCell">Price</td>
              <td class="centeredCell headerCell tableCell">Effect</td>
              <td class="centeredCell headerCell tableCell">Total Charge</td>
              <td class="centeredCell headerCell tableCell"></td>
            </tr>
          </thead>
          @if (entityBreaks() && entityBreaks().length > 0) {
            @for (entityBreak of entityBreaks(); track entityBreak) {
              <tr>
                <td class="tableCell actionCell">
                  <button class="actionButton primary-button" matButton="text" (click)="selectBreak(entityBreak)">
                    <mat-icon>create</mat-icon>
                  </button>
                </td>
                <td class="tableCell">{{ entityBreak.factorCode }}</td>
                <td class="tableCell rightAligned">{{ entityBreak.price | currency:'USD' }}</td>
                <td class="tableCell centeredCell">{{ entityBreak.priceEffect }}</td>
                <td class="tableCell rightAligned">{{ entityBreak.extendedAmount | currency:'USD' }}</td>
                <td class="tableCell actionCell">
                  <button class="actionButton warn-button" matButton="text" (click)="deleteBreak(entityBreak)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </tr>
            }
          }
          @if (!entityBreaks() || entityBreaks().length === 0) {
            <tr>
              <td class="tableCell centeredCell" colspan="6">No breaks found</td>
            </tr>
          }
        </table>
      }
      @if (selectedBreak) {
        <div class="centered">
          <div>
            <label for="factorCodeInput" class="inputLabel">Factor:</label>
            <select id="factorCodeInput" [(ngModel)]="selectedBreak.factorCode" class="inputField">
              <option value="undefined" disabled>Please Select</option>
              @for (factor of factorCodes(); track factor) {
                <option [value]="factor.code">{{ factor.description }}</option>
              }
            </select>
          </div>
          <div>
            <label for="amountInput" class="inputLabel">Amount:</label>
            <input id="amountInput" [(ngModel)]="selectedBreak.price" class="standardTextBox inputField"/>
          </div>
        </div>
      }
    </div>
    @if (errorMessage()) {
      <div class="errorMessage">
        {{ errorMessage() }}
      </div>
    }
  </div>
  @if (isBusy()) {
    <div class="busyIndicator">
      <div class="busyContents">
        <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
        <label class="busyLabel">Please Wait...</label>
      </div>
    </div>
  }
  <div mat-dialog-actions>
    <span class="spacer"></span>
    <span>
      @if (!selectedBreak) {
        <button matButton="elevated" (click)="newBreak()">New</button>
      }
      @if (!selectedBreak) {
        <button matButton="elevated" (click)="close()">Close</button>
      }
      @if (selectedBreak) {
        <button matButton="elevated" (click)="cancelUpdate()">Cancel</button>
      }
      @if (selectedBreak) {
        <button matButton="elevated" [disabled]="!selectedBreak || !selectedBreak.factorCode || !selectedBreak.price" (click)="saveBreak()">Save</button>
      }
    </span>
  </div>
</div>
